const FILE_SIZE_ABBREVIATIONS = ['Bytes', 'KB', 'MB', 'GB']

export const formatFileSize = bytes => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + FILE_SIZE_ABBREVIATIONS[i]
}

export const sizeWithBase64Encoding = bytes => {
  return bytes * 1.33
}
